import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/halloween';
import {setHalloweenModal} from '../../../../reducers/app/actions';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useLocation} from 'react-router-dom';
import Friends from './friends';
import Deposits from './deposits';
import Tickets from './tickets';
import Redeem from './redeem';

export default () => {
    const {halloween, modal} = useSelector(Selector),
          dispatch = useDispatch();

    const closeHandler = e => {
        const overlay = document.querySelector('.h-overlay'),
              modal = document.querySelector('.h-page .h-modal'),
              close = modal.querySelector('.close');

        if(close.contains(e.target) || !modal.contains(e.target)) {
            modal.classList.remove('animate__fadeInUp');
            modal.classList.add('animate__fadeOutDown');

            overlay.classList.remove('animate__fadeIn');
            overlay.classList.add('animate__fadeOut');

            setTimeout(() => {
                dispatch(setHalloweenModal(null));
                overlay.classList.remove('animate__fadeOut');
                overlay.classList.add('animate__fadeIn');
            }, 500);
        }

        // console.log(e.target, close);

        
    }

    useEffect(() => {
        if(modal)
            document.addEventListener('mouseup', closeHandler);

        return () => document.removeEventListener('mouseup', closeHandler);
    }, [modal]);

    return (
        <div className="h-overlay animate__animated animate__fadeIn animate__faster" style={{display: modal ? 'flex' : 'none'}}>
            {modal === "friends" && <Friends />}
            {modal === "deposits" && <Deposits />}
            {modal === "tickets" && <Tickets />}
            {modal === "redeem" && <Redeem />} 
        </div>
    )
}